
























































import Vue, { PropType } from 'vue'
import {
  parseISO,
  differenceInDays,
  isValid as isValidDate,
  format,
  parseJSON,
  isValid,
} from 'date-fns'
import { DataTableHeader } from 'vuetify'
import { PropertyMap } from '@/components/gmap/'
import { ValidatedResponse } from '../../interfaces/app/ValueObjects'
import { getNestedValue } from '../../util/helpers'
import { MapMarker } from '../../interfaces/gmap/Map'
import client from '../../services/api/client'
import { formatMoneyFilter, numberToFixed } from '../../plugins/filters'
import { BuildingType } from '../../interfaces/valuation/types/BuildingValuationStep'

interface DataOptions {
  page: number
  pageCount: number
  itemsPerPage: number
  headers: DataTableHeader[]
}

export default Vue.extend({
  components: {
    PropertyMap,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  data(): DataOptions {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        {
          text: 'Jednotka',
          value: 'unitCode',
          sortable: false,
        },
        {
          text: 'Projekt',
          value: 'projectName',
          sortable: false,
        },
        {
          text: 'Popis jednotky',
          value: 'unitTypeDesc',
          sortable: false,
        },

        {
          text: 'NP',
          value: 'floorDesc',
          sortable: false,
        },
        {
          text: 'Dispozice',
          value: 'apartmentTypeDesc',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha jednotky',
          value: 'unitArea',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha balkonu',
          value: 'unitAreaBalcony',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha lodžie',
          value: 'unitAreaLoggia',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha terasy',
          value: 'unitAreaTerrace',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha pozemku',
          value: 'unitAreaGround',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha sklepa',
          value: 'unitAreaC',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Ceníková cena jednotky',
          value: 'priceTotal',
          sortable: false,
        },
        // { text: 'ID nabídky', value: 'transactionID', sortable: false },
        // { text: 'Ulice', value: 'adresa', sortable: false, width: 200 },
        // {
        //   text: 'Dispozice',
        //   value: 'category',
        //   sortable: false,
        //   align: 'center',
        // },
        // {
        //   text: 'Plocha m²',
        //   value: 'usableArea',
        //   sortable: false,
        //   align: 'center',
        // },
        // { text: 'Vznik', value: 'created', sortable: false, align: 'center' },
        // {
        //   text: 'Prodej',
        //   value: 'transactionDate',
        //   sortable: false,
        //   align: 'center',
        // },
        // {
        //   text: 'Doba nabídky',
        //   value: 'duration',
        //   sortable: false,
        //   align: 'center',
        // },
        // {
        //   text: 'Cena celkem',
        //   value: 'priceTotal',
        //   sortable: false,
        //   width: 100,
        // },
        // { text: 'Cena za m²', value: 'price', sortable: false, width: 100 },
        // { text: 'Podlaží', value: 'storey', sortable: false, align: 'center' },
        // { text: 'Vlastnictví', value: 'ownership', sortable: false },
        // {
        //   text: 'Vzdálenost od posuzované jednotky v m',
        //   value: 'distance',
        //   sortable: false,
        //   width: 50,
        // },
        // { text: 'Stav', value: 'objectState', sortable: false },
      ],
    }
  },
})
